import type { CpsDocumentMetadata } from '@cs-cms/types';
import { MASTER_FIELD_PREFIX, RT_MASTER_EMPTY_PLACEHOLDER } from './masterFieldConstants';

const isMetadataValueEmpty = (value: unknown): boolean => {
  if (value === null || value === undefined) {
    return true;
  }
  if (typeof value === 'string') {
    return value.trim() === '';
  }
  return false;
};

const toComparableMetadataScalar = (value: unknown): string => {
  if (value === null || value === undefined) {
    return '';
  }
  if (value instanceof Date) {
    return value.toISOString();
  }
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }
  return String(value);
};

const masterBaseValuesMatchForSubmit = (masterVal: unknown, baseVal: unknown): boolean => {
  if (masterVal === baseVal) {
    return true;
  }
  if (isMetadataValueEmpty(masterVal) && isMetadataValueEmpty(baseVal)) {
    return true;
  }
  if (masterVal === RT_MASTER_EMPTY_PLACEHOLDER && isMetadataValueEmpty(baseVal)) {
    return true;
  }
  return toComparableMetadataScalar(masterVal) === toComparableMetadataScalar(baseVal);
};

export const stripRedundantMasterMetadata = (metadata: CpsDocumentMetadata): CpsDocumentMetadata => {
  const result: CpsDocumentMetadata = { ...metadata };

  for (const key of Object.keys(result)) {
    if (!key.startsWith(MASTER_FIELD_PREFIX)) {
      continue;
    }

    const baseKey = key.slice(MASTER_FIELD_PREFIX.length);
    if (!Object.prototype.hasOwnProperty.call(result, baseKey)) {
      continue;
    }

    const masterVal = result[key];
    const baseVal = result[baseKey];

    if (isMetadataValueEmpty(masterVal) || masterBaseValuesMatchForSubmit(masterVal, baseVal)) {
      delete result[key];
    }
  }

  return result;
};
